import { render, staticRenderFns } from "./AssessmentExams.vue?vue&type=template&id=6e30916a&"
import script from "./AssessmentExams.vue?vue&type=script&lang=js&"
export * from "./AssessmentExams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports